
import React from "react";
import { Link } from "react-router-dom";
import "../../styles/cloud-login-link.css";

const CloudLoginLink = () => {
  return (
    <div className="cloud-login-wrapper">
      <Link 
        to="/auth" 
        className="cloud-login-link"
        data-spark="true"
        data-spark-type="link"
      >
        Login to view your collection
      </Link>
    </div>
  );
};

export default CloudLoginLink;
